import { trackGoogleAnalyticsConversion } from "@webcore/services/telemetry/googleAnalytics.ts";
import { LeadConversionInfo } from "@webcore/services/leadIntake/leadIntake.ts";

/**
 * Conversion tracking for a successful lead-form submission. Called only after the intake
 * endpoint returned 200. Pushes `lead_form_submit` to the GTM dataLayer (marketing owns the
 * trigger inside the container) and sends `generate_lead` to GA4 through the shared gtag helper.
 * Only non-personal fields go to analytics — never name, email, or company.
 */
export function trackLeadFormSubmit(info: LeadConversionInfo): void {
  window.dataLayer = window.dataLayer ?? [];
  window.dataLayer.push({ event: "lead_form_submit", page_slug: info.page_slug, utm_source: info.utm_source });

  void trackGoogleAnalyticsConversion("generate_lead", { page_slug: info.page_slug, utm_source: info.utm_source });
}
